import { initReactI18next } from 'react-i18next';
import { Capacitor } from '@capacitor/core';
import i18n, { type Resource } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const loadTranslationsFile = async (): Promise<Resource | undefined> => {
  const enTranslations = (await import('../public/locales/en/en.json')).default;
  const ruTranslations = (await import('../public/locales/ru/ru.json')).default;
  // const deTranslations = await import('public/locales/de/de.json');
  // const esTranslations = await import('public/locales/es/es.json');
  // const jaTranslations = await import('public/locales/ja/ja.json');
  // const ptTranslations = await import('public/locales/pt/pt.json');
  // const viTranslations = await import('public/locales/vi/vi.json');
  // const zhTranslations = await import('public/locales/zh/zh.json');

  return {
    en: { translation: enTranslations },
    ru: { translation: ruTranslations },
    // de: { translation: deTranslations },
    // es: { translation: esTranslations },
    // ja: { translation: jaTranslations },
    // pt: { translation: ptTranslations },
    // vi: { translation: viTranslations },
    // zh: { translation: zhTranslations },
  };
};

const resources = await loadTranslationsFile();

// В нативном приложении язык берётся из системы, как у обычных iOS-приложений:
// меняется в Настройки → Star Industry → Язык (iOS видит en/ru из
// CFBundleLocalizations в Info.plist и перезапускает приложение).
// Русский только для ru-устройств, всем остальным — английский.
export const isSystemLanguage = Capacitor.isNativePlatform();
export const getSystemLanguage = (): 'en' | 'ru' =>
  (navigator.languages?.[0] ?? navigator.language ?? '')
    .toLowerCase()
    .startsWith('ru')
    ? 'ru'
    : 'en';
// export const initializeI18n = async () => {
//   const resources = await loadTranslationsFile();
// };
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: isSystemLanguage ? getSystemLanguage() : undefined,
    resources,
    // resources: {
    //   en: {
    //     translation: {
    //       'Settings': 'Settings',
    //       'Welcome to Star Industry!': 'Welcome to Star Industry!',
    //     },
    //   },
    //   ru: {
    //     translation: {
    //       'Settings': 'Настройки',
    //       'Welcome to Star Industry!': 'Добро пожаловать в Star Industry!',
    //     },
    //   },
    // },
    detection: {
      order: ['localStorage', 'navigator'], // Спочатку перевіряється localStorage, потім налаштування браузера
      caches: ['localStorage'], // Зберігаємо вибір мови у localStorage
    },
    interpolation: {
      escapeValue: false,
    },
  });

// initializeI18n().then(() => {
//   console.log('i18n ініціалізовано');
// });

export default i18n;
